import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ProfileContext } from 'context';
import { getStandards } from 'helpers/standards';
import { countrySettings as countrySettingsSelector } from 'modules/App/selectors';
export const useStandards = (isAGP = false)=>{
    const profileContext = useContext(ProfileContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const clinicSettings = useSelector(profileContext.selectors.clinicSettings);
    const countrySettings = useSelector(countrySettingsSelector);
    const standards = useMemo(()=>getStandards(phiSet, countrySettings, clinicSettings, isAGP), [
        phiSet,
        countrySettings,
        clinicSettings,
        isAGP
    ]);
    return standards;
};
